import styled from "styled-components"

import { createNavigator } from "Catalog/Edit/shared/components/Navigator"
import { ICategoryOrProduct } from "shared/hubrise/models"

export const constants = {
  categoryGap: "0.75em",
}

export const ProductNavigator = createNavigator<ICategoryOrProduct>()

export const StyledProductNavigator = styled(ProductNavigator)`
  margin-top: -${constants.categoryGap};
`
